import type { SVGProps } from 'react'
const SvgRevalidate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 15.75C9.3 15.75 10.4167 15.2833 11.35 14.35C12.2833 13.4167 12.75 12.3 12.75 11C12.75 9.7 12.2833 8.58333 11.35 7.65C10.4167 6.71667 9.3 6.25 8 6.25C7.36667 6.25 6.775 6.36667 6.225 6.6C5.675 6.83333 5.18333 7.15 4.75 7.55V6H3.25V10.25H7.5V8.75H5.7C5.98333 8.45 6.325 8.20833 6.725 8.025C7.125 7.84167 7.55 7.75 8 7.75C8.9 7.75 9.66667 8.06667 10.3 8.7C10.9333 9.33333 11.25 10.1 11.25 11C11.25 11.9 10.9333 12.6667 10.3 13.3C9.66667 13.9333 8.9 14.25 8 14.25C7.26667 14.25 6.625 14.0375 6.075 13.6125C5.525 13.1875 5.13333 12.65 4.9 12H3.35C3.58333 13.0833 4.12917 13.9792 4.9875 14.6875C5.84583 15.3958 6.85 15.75 8 15.75ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H10L16 6V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM2 18H14V6.85L9.15 2H2V18Z"
      fill="#5E5E5E"
    />
  </svg>
)
export default SvgRevalidate
